import React from 'react'
import Appspage from '../components/Appspage/Appspage'

function Apps() {
  return (
    <div>
      <Appspage/>
      
    </div>
  )
}

export default Apps
